import { FileType } from '~/core/enums'

export const isPDF = (file: File) => {
  return file.type === FileType.Pdf
}
